import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'utils/debounce';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const setDebounced = useMemo(() => debounce(setDebouncedValue, delay), [delay]);

  useEffect(() => {
    setDebounced(value);
    return () => {
      setDebounced.cancel();
    };
  }, [value, setDebounced]);

  return debouncedValue;
}
